import { useMutation } from '@tanstack/react-query'

import { APIInstance } from '@/utils/functions/instance'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

export function useRegisterMerchantDocuments({
  disableToast,
  ...rest
}: IApiBaseTypes<{}> = {}) {
  return useMutation({
    mutationFn: async () =>
      await APIInstance<IResponseType<{}>>({
        url: 'mrf/documents/register/',
        method: 'post'
      }),
    mutationKey: ['registerMerchantDocument'],
    retry: 0,
    ...rest
  })
}
